import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { SpeseLegaliForm } from "../../../form/spese-legali-form/spese-legali-form";
import { SpesaLegale } from "../../../models/tipologiche/spesa-legale";


import { FormValidationService } from '../../../services/form-validation.service';
import { SpeseLegaliAdapter } from './spese-legali-adapter';

declare var closeModal: any;

@Component({
    selector: 'div [spese-legali-form-update]',
    templateUrl: '../../../form/spese-legali-form/spese-legali-form.html',
    host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class SpeseLegaliFormUpdateComponent extends SpeseLegaliForm implements OnInit {
  private spesaLegale: SpesaLegale;
  private urlUpdate: string;
  @Input() tipoPetitium: string;
  @Output() onReturn: EventEmitter<SpesaLegale> = new EventEmitter<SpesaLegale>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService) {
        super(operationService, campiForm, helpers, formValidationService);
  }
  ngOnInit() {
    this.setTitle('Modifica Spese Legali');
    this.isInserimento(false);
  }

  getAdapter(): SpesaLegale {
    return new SpeseLegaliAdapter(this.spesaLegale).spesaLegale;
  }

  getRequest(spesaLegale: SpesaLegale) {
    this.onReturn.emit(spesaLegale);
  }

  inizializza(spesaLegale: SpesaLegale, tipoPetitium) {
    this.spesaLegale = spesaLegale;
    this.populateSelect();
    this.createForm(tipoPetitium);
  }
}
